import { http, httpCadastro, httpFinanceiro } from "../plugins/http";

let endpoint = "/v1/cadastro";

export default {

criarFaturaAdesao: (cnpj) => {
  return httpFinanceiro.post(
    '/v1/api/fatura/adesao/criar',
    null,
    {
      params: { cnpjTransportador: String(cnpj).replace(/\D/g, '') },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }
  );
},

  getTransportadores: (tipoFiltro, valor, status, tipo) => {
    let url =
      endpoint +
      "/participante" +
      "/busca?tipoFiltro=" +
      tipoFiltro +
      "&valor=" +
      valor +
      "&status=" +
      status +
      "&tipo=" +
      tipo;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getTransportadoresUsuario: (idUsuario) => {
    let url =
      endpoint + "/participante" + "/busca-usuario?idUsuario=" + idUsuario;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getCpfCnpj: (cpfCnpj, tipo) => {
    let url =
      endpoint + "/participante/cpf-cnpj?cpfCnpj=" + cpfCnpj + "&tipo=" + tipo;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  insertTransportador: (transportadorData) => {
    return httpCadastro.post(endpoint + "/participante", transportadorData, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  updateTransportador: (id, transportadorData) => {
    return httpCadastro.put(
      `${endpoint + "/participante"}/${id}`,
      transportadorData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  /**
   * Busca participante completo (com endereco aninhado, telefone, etc).
   * Usado pela rotina CIOT quando precisamos dos dados de endereco/contato
   * do transportador (bloco Proprietario quando o veiculo eh proprio).
   */
  getTransportadorById: (id) => {
    return httpCadastro.get(`${endpoint}/participante/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  liberarPreCadastro: (id) => {
    return httpCadastro.put(
      `${endpoint + "/participante/pre-cadastro"}/${id}`,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  //
  // Update isolado de RNTRC do transportador. Backend sanitiza pra digits
  // e trunca em 8. Aceita rntrc null/vazio pra limpar.
  // Usado pelo botao "Adicionar RNTRC" da Lista de Transportadores.
  //
  setRntrcParticipante: (id, rntrc) => {
    const param = rntrc != null ? rntrc : ''
    return httpCadastro.patch(
      `${endpoint}/participante/${id}/rntrc?rntrc=${encodeURIComponent(param)}`,
      null,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  //
  // Habilita ou desabilita a emissao de NFS-e pela Work em nome do
  // participante. E o UNICO caminho que altera o flag: desde o PR #98 da
  // cadastro, o POST nasce com 0 fixo e o PUT nao toca na coluna.
  //
  // Atencao: diferente do setRntrcParticipante aqui em cima, o valor vai
  // no CORPO, nao na query string. Responde 200 com o participante
  // completo - use o retorno pra atualizar a tela, sem refazer o GET.
  //
  habilitarNfseParticipante: (id, habilitado) => {
    return httpCadastro.patch(
      `${endpoint}/participante/${id}/habilita-nfse`,
      { habilitado: !!habilitado },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  //
  // Series DPS do DOCUMENTO do participante, nao do id: matriz e filial
  // sao participantes distintos, mas CNPJs iguais compartilham series.
  // Traz PRODUCAO e HOMOLOGACAO; so a de producao serve pra emitir.
  //
  listarSeriesDpsNfse: (idParticipante) => {
    return httpCadastro.get(
      `${endpoint}/participante/${idParticipante}/nfse/series-dps`,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  //
  // 201 sem corpo - quem chama precisa refazer a listagem depois.
  //
  // Nao existe endpoint pra alterar, desativar ou excluir serie: errar o
  // numero inicial so se corrige por DBA. Por isso a tela confirma antes.
  //
  cadastrarSerieDpsNfse: (idParticipante, dados) => {
    return httpCadastro.post(
      `${endpoint}/participante/${idParticipante}/nfse/series-dps`,
      {
        serie: String(dados.serie),
        ultimoNumeroUtilizado: Number(dados.ultimoNumeroUtilizado),
      },
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  salvarUsuario: (usuarioData) => {
    let url = endpoint + "/participante/usuario";

    return httpCadastro.post(url, usuarioData, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  salvarCpfMotorista: (cpfMotorista) => {
    let url =
      "https://api.auth.workinnovation.com.br/v1/api/seg/usuarios/condutor/parametrizacao";

    return httpCadastro.post(url, cpfMotorista, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    });
  },

  salvarConfigAverbacao: (idTransportador, configData) => {
    return httpCadastro.put(
      `${endpoint + "/participante-config"}/${idTransportador}`,
      configData,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  getConfigAverbacao: (idTransportador) => {
    let url = endpoint + "/participante-config/" + idTransportador;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  salvarCertificado: (arquivo, cnpj, senha) => {
    const formData = new FormData();
    formData.append("arquivo", arquivo);
    formData.append("cnpj", cnpj);
    formData.append("senha", senha);

    return httpCadastro
      .post(`${endpoint + "/certificado"}`, formData, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },

  getPartCertificado: (tipoFiltro, valor, status, tipo, idUsuario) => {
    let url =
      endpoint +
      "/participante" +
      "/participante-certificado?tipoFiltro=" +
      tipoFiltro +
      "&valor=" +
      valor +
      "&status=" +
      status +
      "&tipo=" +
      tipo +
      "&idUsuario=" +
      idUsuario;
    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getMotoristas: (idParticipante) => {
    let url =
      endpoint +
      "/participante-motorista" +
      "/busca?idParticipante=" +
      idParticipante;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  // Retorna todos os motoristas dos participantes do usuario em UMA chamada
  // (substitui o N+1 de getMotoristas por participante).
  getMotoristasUsuario: (idUsuario) => {
    let url =
      endpoint + "/participante-motorista/busca-usuario?idUsuario=" + idUsuario;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  // Busca um ParticipanteMotorista (vinculo) pelo id do vinculo.
  // Retorno: { id, participante: {...}, motorista: {...} }
  getParticipanteMotoristaById: (id) => {
    return httpCadastro.get(`${endpoint}/participante-motorista/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getCpfMotorista: (cpf) => {
    let url = endpoint + "/motorista/cpf?cpf=" + cpf;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  deletarMotorista: (id) => {
    return httpCadastro.delete(`${endpoint}/participante-motorista/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  insertMotorista: (participanteMotorista) => {
    return httpCadastro.post(
      endpoint + "/participante-motorista",
      participanteMotorista,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  updateMotorista: (id, participanteMotorista) => {
    return httpCadastro.put(
      `${endpoint + "/participante-motorista"}/${id}`,
      participanteMotorista,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  getVeiculos: (idParticipante) => {
    let url =
      endpoint +
      "/participante-veiculo" +
      "/busca?idParticipante=" +
      idParticipante;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  // Busca um vinculo participante-veiculo pelo id do vinculo (1 request,
  // em vez de baixar todos os veiculos de todos os participantes).
  getVeiculoById: (id) => {
    return httpCadastro.get(`${endpoint}/participante-veiculo/${id}`, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  // Todos os veiculos dos participantes do usuario em UMA chamada
  // (substitui o N+1 de getVeiculos por participante).
  getVeiculosUsuario: (idUsuario) => {
    let url =
      endpoint + "/participante-veiculo/busca-usuario?idUsuario=" + idUsuario;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  // Checagem direcionada de placa duplicada (participante + placa),
  // sem baixar todos os veiculos do participante.
  getVeiculoPorPlacaParticipante: (idParticipante, placa) => {
    let url =
      endpoint +
      "/participante-veiculo/busca-placa?idParticipante=" +
      idParticipante +
      "&placa=" +
      encodeURIComponent(placa);

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  getPlacaVeiculo: (placa) => {
    let url = endpoint + "/veiculo/placa?placa=" + placa;

    return httpCadastro.get(url, {
      headers: { Authorization: "Bearer " + localStorage.getItem("token") },
    });
  },

  // deletarVeiculo removido intencionalmente. O endpoint
  // DELETE /participante-veiculo/{id} no backend apaga o vinculo
  // permanentemente (placa some da lista do usuario). Regra do produto:
  // so inativar, via PATCH /participante-veiculo/{id}/ativo (ver
  // ListaVeiculos.vue / Transportador.setAtivoVeiculo).

  insertVeiculo: (participanteVeiculo) => {
    return httpCadastro.post(
      endpoint + "/participante-veiculo",
      participanteVeiculo,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  updateVeiculo: (id, participanteVeiculo) => {
    return httpCadastro.put(
      `${endpoint + "/participante-veiculo"}/${id}`,
      participanteVeiculo,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  // Toggle de ativo SOH no vinculo (participante_veiculo.ativo).
  // Endpoint dedicado evita o bug de "inativar 1 inativa os 2" quando 2
  // participantes apontam pro mesmo cadastro.veiculo - o PUT completo
  // atualizava cadastro.veiculo (compartilhada).
  setAtivoVeiculo: (id, ativo) => {
    return httpCadastro.patch(
      `${endpoint}/participante-veiculo/${id}/ativo?ativo=${ativo}`,
      null,
      {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      }
    );
  },

  uploadDocumentoVeiculo: (arquivo, cnpj, tipoDocumento) => {
    const formData = new FormData();
    formData.append("arquivo", arquivo);
    formData.append("cnpj", cnpj);
    formData.append("tipo", tipoDocumento);
    return http.post("/documento-veiculo/upload", formData, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    });
  },
};
